export const basic = [
  { key: 'year', label: 'Year' },
  { key: 'team_id', label: 'School', class: 'team-name-col !text-left' },
  { key: 'games_played', label: 'GP' },
  { key: 'batting_average', label: 'BA' },
  { key: 'on_base_percentage', label: 'OBPct' },
  { key: 'slugging_percentage', label: 'SlgPct' },
  { key: 'runs_scored', label: 'R' },
  { key: 'at_bats', label: 'AB' },
  { key: 'hits', label: 'H' },
  { key: 'doubles', label: '2B' },
  { key: 'triples', label: '3B' },
  { key: 'total_bases', label: 'TB' },
  { key: 'home_runs', label: 'HR' },
  { key: 'runs_batted_in', label: 'RBI' },
  { key: 'walks', label: 'BB' },
  { key: 'hit_by_pitch', label: 'HBP' },
  { key: 'sac_fly', label: 'SF' },
  { key: 'sac_hit', label: 'SH' },
  { key: 'strikeouts', label: 'K' },
  { key: 'caught_stealing', label: 'CS' },
  { key: 'picked_off', label: 'Picked' },
  { key: 'stolen_bases', label: 'SB' },
  { key: 'intentional_walk', label: 'IBB' },
  { key: 'plate_appearances', label: 'PA' },
];
export const basicTeam = [
  { key: 'year', label: 'Year' },
  { key: 'games_played', label: 'GP' },
  { key: 'batting_average', label: 'BA' },
  { key: 'on_base_percentage', label: 'OBPct' },
  { key: 'slugging_percentage', label: 'SlgPct' },
  { key: 'runs_scored', label: 'R' },
  { key: 'at_bats', label: 'AB' },
  { key: 'hits', label: 'H' },
  { key: 'doubles', label: '2B' },
  { key: 'triples', label: '3B' },
  { key: 'total_bases', label: 'TB' },
  { key: 'home_runs', label: 'HR' },
  { key: 'runs_batted_in', label: 'RBI' },
  { key: 'walks', label: 'BB' },
  { key: 'hit_by_pitch', label: 'HBP' },
  { key: 'sac_fly', label: 'SF' },
  { key: 'sac_hit', label: 'SH' },
  { key: 'strikeouts', label: 'K' },
  { key: 'caught_stealing', label: 'CS' },
  { key: 'picked_off', label: 'Picked' },
  { key: 'stolen_bases', label: 'SB' },
  { key: 'intentional_walk', label: 'IBB' },
  { key: 'plate_appearances', label: 'PA' },
];

export const advanced = [
  { key: 'year', label: 'Year' },
  { key: 'team_id', label: 'School', class: 'team-name-col !text-left' },
  { key: 'on_base_plus_slugging', label: 'OPS' },
  { key: 'strikeout_percentage', label: 'K%' },
  { key: 'walk_percentage', label: 'BB%' },
  { key: 'strikeout_to_walk_ratio', label: 'K:BB' },
  { key: 'isolated_power', label: 'ISO' },
  { key: 'batting_average_on_balls_in_play', label: 'BABIP' },
  { key: 'weighted_on_base_average', label: 'wOBA' },
  { key: 'weighted_runs_created', label: 'wRC' },
  { key: 'weighted_runs_above_average', label: 'wRAA' },
  { key: 'weighted_runs_created_plus', label: 'wRC+' },
  { key: 'runs_plate_appearance', label: 'R/PA' },
];

export const advancedTeam = [
  { key: 'year', label: 'Year' },
  { key: 'on_base_plus_slugging', label: 'OPS' },
  { key: 'strikeout_percentage', label: 'K%' },
  { key: 'walk_percentage', label: 'BB%' },
  { key: 'strikeout_to_walk_ratio', label: 'K:BB' },
  { key: 'isolated_power', label: 'ISO' },
  { key: 'batting_average_on_balls_in_play', label: 'BABIP' },
  { key: 'weighted_on_base_average', label: 'wOBA' },
  { key: 'weighted_runs_created', label: 'wRC' },
  { key: 'weighted_runs_above_average', label: 'wRAA' },
  { key: 'weighted_runs_created_plus', label: 'wRC+' },
  { key: 'runs_plate_appearance', label: 'R/PA' },
];
